import {Map} from 'immutable'
import PropTypes from 'prop-types'

import {isDeferredReadResponseGroup} from '../../lib/deputyPermissionTools'
import {formatDate} from '../../lib/dateTools'

import './itemResponseGroupInformation.scss'

const ItemResponseGroupInformation = ({
  context,
  deputyOwnership,
  firstGroupId,
  ownEverplan,
  responseGroup = Map()
}) => {
  if (context === 'everplan_preview' &&
    !ownEverplan &&
    isDeferredReadResponseGroup({deputyOwnership, firstGroupId})) {
    return (
      <span className='unlock-state flex-child'>
        <i className='fa fa-flip-horizontal fa-unlock' aria-hidden={true} />
        Unlocked
      </span>
    )
  } else {
    return (
      <div className='value last-updated flex-child'>
        {formatDate(responseGroup.get('last-updated-at'))}
      </div>
    )
  }
}

ItemResponseGroupInformation.propTypes = {
  ownEverplan: PropTypes.bool,
  context: PropTypes.string,
  firstGroupId: PropTypes.string,
  deputyOwnership: PropTypes.instanceOf(Map),
  responseGroup: PropTypes.instanceOf(Map)
}

export default ItemResponseGroupInformation

